export {cloneObject};
function cloneObject(d) {
    return JSON.parse(JSON.stringify(d));
}